// European sites with GDPR policy handling
export const EU_SITE_COOKIE_NAME = 'eu-site';
// Protection of selling personal information under California or Nevada law
export const CCPA_STATE_COOKIE_NAME = 'dnsmpi';
// Custom event to call when page query change ( page refresh )
export const ADS_REFRESH_EVENT = 'DisplayAdRefresh';
